/**
 * groupBy - groups array item by given field name
 * @param xs - Array if item
 * @param key - field name to group by
 */
export function groupBy<T>(xs, key): {[key:string]:T[] } {
    return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key] as T] || []).push(x);
        return rv;
    }, {});
}
